export default {
  marca: process.env.REACT_APP_MARCA,
  apiUrl: process.env.REACT_APP_API_URL,
  ssoUrl: process.env.REACT_APP_SSO_URL,
};
